<template>
  <div class="item-quick-edit">
    <div class="quantity-price">
      <div class="form-group">
        <div class="input-group">
          <button @click.stop="quantityDown" class="btn input-group-btn"><fa-icon icon="angle-down" size="lg"></fa-icon></button>
          <input type="text" class="form-input qty-amount" v-model="quantityNeeded" placeholder="Quantity...">
          <button @click.stop="quantityUp" class="btn input-group-btn"><fa-icon icon="angle-up" size="lg"></fa-icon></button>
        </div>
        <div class="input-group">
          <span class="input-group-addon">Price Each:</span>
          <input class="form-input qty-price" type="number" step="0.01" min="0" v-model="priceEachDollars" placeholder="Price...">
        </div>
      </div>
    </div>
    <div class="name-notes">
      <div class="form-group">
        <div class="input-group" :class="{'has-error': nameError}">
          <span class="input-group-addon">Name:</span>
          <input class="form-input" type="text" v-model="name" ref="name">
        </div>
        <div class="input-group">
          <span class="input-group-addon">Notes:</span>
          <input class="form-input" type="text" v-model="notes" ref="notes">
          <button @click.stop="clearNotes" class="btn input-group-btn"><fa-icon icon="times-circle"></fa-icon></button>
        </div>
      </div>
    </div>
    <div class="more-details">
      <button class="btn btn-primary" @click.stop="moreDetails">&hellip;</button>
    </div>
    <div class="controls">
      <button class="btn btn-success" @click.stop="save"><fa-icon icon="check"></fa-icon></button>
      <button class="btn" @click.stop="cancel"><fa-icon icon="times"></fa-icon></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeededItemQuickEditor',
  props: {
    item: { type: Object, required: true }
  },
  data () {
    // Quick edit value sandbox
    return {
      name: this.item.name,
      notes: this.item.notes,
      priceEachDollars: this.item.priceEachCents ? (this.item.priceEachCents / 100.0).toFixed(2) : '',
      quantityNeeded: this.item.quantityNeeded,
      nameError: false
    }
  },
  methods: {
    quantityDown () {
      this.quantityNeeded--
      if (this.quantityNeeded < 0) {
        this.quantityNeeded = 0
      }
    },
    quantityUp () {
      this.quantityNeeded++
    },
    clearNotes () {
      this.notes = ''
      this.$refs['notes'].focus()
    },
    cancel () {
      this.$emit('close')
    },
    save () {
      if (this.nameError) {
        this.$refs['name'].focus()
        return
      }
      this.updateItem({
        id: this.item.id,
        name: this.name,
        notes: this.notes.trim(),
        priceEachCents: Math.floor(parseFloat(this.priceEachDollars) * 100),
        quantityNeeded: parseInt(this.quantityNeeded || '0', 10),
        // Copy-over from core record
        isOneTimeItem: this.item.isOneTimeItem,
        isEventualPurchase: this.item.isEventualPurchase,
        storeIds: this.item.storeIds,
        categoryId: this.item.categoryId
      })
      this.$emit('close')
    },
    moreDetails () {
      this.$emit('more-details')
    }
  },
  watch: {
    name () {
      this.nameError = !this.name.length
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/_vars';

  .item-quick-edit {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    flex-wrap: nowrap;
    width: 100%;
    padding: 0;

    .form-group {
      .input-group + .input-group {
        margin-top: 0.2rem;
      }
    }

    .input-group-addon {
      border: 1px solid $primary-color;
      font-size: 0.7rem;
      background-color: $light-color;
      color: $dark-color;
    }

    .quantity-price {
      flex: 1 1 10rem;
      margin: 0.25rem 0 0.25rem 0.25rem;

      .input-group-btn {
        flex-basis: 25%;
      }

      input.qty-amount {
        text-align: center;
      }
      input.qty-price {
        text-align: right;
      }
    }

    .name-notes {
      flex: 1 1 70%;
      margin: 0.25rem 0 0.25rem 0.25rem;
    }

    .more-details {
      flex: 1 1 2rem;
      margin: 0.25rem 0 0.25rem 0.25rem;
      display: flex;
      align-items: stretch;
      align-content: stretch;
      .btn {
        flex: 1 1 auto;
        height: 100%;
        width: 100%;
        font-size: 2rem;
        padding-bottom: 1.25rem;
        display: flex;
        align-content: center;
        justify-content: center;
      }
    }

    .controls {
      flex: 1 1 3rem;
      margin: 0 0 0 0.25rem;
      display: flex;
      flex-direction: column;
      border-left: 1px solid $dark-color;

      .btn {
        border-radius: 0;
        border: none;
        flex: 1 1 auto;
        &.btn-success {
          color: $bg-color;
        }
      }
    }

    @media (max-width: $size-sm) {
      flex-direction: column;

      .quantity-price, .name-notes, .more-details, .controls {
        margin: 0.25rem;
        flex: 1 1 auto;
      }

      .more-details {
        .btn {
          font-size: 1.6rem;
          line-height: 0.2rem;
          padding-bottom: 1.2rem;
        }
      }
      .controls {
        flex-direction: row-reverse;
        border-left: none;
      }
    }
  }
</style>
